import { message as AntdMessage } from "antd";

export interface MessageStaticMethods {
  success: typeof AntdMessage.success;
  error: typeof AntdMessage.error;
  info: typeof AntdMessage.info;
  warning: typeof AntdMessage.warning;
  loading: typeof AntdMessage.loading;
  open: typeof AntdMessage.open;
  config: typeof AntdMessage.config;
  destroy: typeof AntdMessage.destroy;
}

const MessagePolyfill: MessageStaticMethods = {
  success: AntdMessage.success,
  error: AntdMessage.error,
  info: AntdMessage.info,
  warning: AntdMessage.warning,
  loading: AntdMessage.loading,
  open: AntdMessage.open,
  config: AntdMessage.config,
  destroy: AntdMessage.destroy,
};

export default MessagePolyfill;
